import React from 'react';
import { Pagination, Select } from 'antd';

export default function MyPagination({ total, page, setPage, pageSize, setPageSize, alwaysShow = false }) {

    const pageOptions = [{ value: 10, label: '10 / Page' }, { value: 20, label: '20 / Page' }, { value: 50, label: '50 / Page' }, { value: 100, label: '100 / Page' }];

    const handleChange = (value) => {
        setPageSize(value);
        setPage(1);
    }

    return (
        <>
            {(alwaysShow || total > 10) && (
                <div className='w-full flex xl:justify-between items-center justify-end pt-6'>
                    <div className='ant-select-selector-white hidden xl:block'>
                        <Select className="w-[140px]" defaultValue={pageSize} options={pageOptions} onChange={handleChange} />
                    </div>
                    <Pagination current={page} total={total} showSizeChanger={false} pageSize={pageSize} onChange={(value) => setPage(value)} />
                </div>
            )}
        </>
    )
}